export enum FieldCategory {
  Custom = 'custom',
  Default = 'default',
}
